import type { Route } from './router.js';

/**
 * WHAT A BACK CHIP SAYS WHEN IT RETURNS TO A SCREEN (0.1.524) — one vocabulary, because the chip
 * now names whatever screen is actually behind this one (`previousRoute`), not a parent each
 * screen spelled for itself. A detail screen reads "Back to the …"; a list or tab reads its own
 * name, which is the wording the item chip (`← Items`) and the list chips have always used.
 */
export function routeBackLabel(route: Route): string {
  switch (route.name) {
    case 'item':
      return '← Back to the item';
    case 'booking':
      return '← Back to the reservation';
    case 'box':
      return '← Back to the box';
    case 'outfit':
      return '← Back to the outfit';
    case 'project':
      return '← Back to the project';
    case 'character':
      return '← Back to the character';
    case 'booking-checkin':
      return '← Back to the check-in';
    case 'items':
      return '← Items';
    case 'reservations':
      return '← Reservations';
    case 'checkouts':
      return '← Check-outs';
    case 'boxes':
      return '← Boxes';
    case 'outfits':
      return '← Outfits';
    case 'projects':
      return '← Projects';
    case 'racks':
      return '← Rack location';
    case 'scan':
      return '← Scan';
    case 'dashboard':
      return '← Dashboard';
    case 'maintenance':
      return '← Maintenance';
    case 'retour':
      return '← Retour';
    case 'settings':
      return '← Settings';
    case 'users':
      return '← Users';
    default:
      return '← Back';
  }
}
